// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class TenantPrescriberPrescriberSearchPrescriberSearchResponseData {
    static getAttributeTypeMap() {
        return TenantPrescriberPrescriberSearchPrescriberSearchResponseData.attributeTypeMap;
    }
}
TenantPrescriberPrescriberSearchPrescriberSearchResponseData.discriminator = undefined;
TenantPrescriberPrescriberSearchPrescriberSearchResponseData.additionalProperties = false;
TenantPrescriberPrescriberSearchPrescriberSearchResponseData.attributeTypeMap = [
    {
        "name": "prescribers",
        "baseName": "prescribers",
        "type": ""
    },
];
//# sourceMappingURL=tenantPrescriberPrescriberSearchPrescriberSearchResponseData.js.map